module.exports = __webpack_public_path__ + "img/google-plus-square.4e121b01.svg";